// import Fonts from './Fonts'
// import Colors from './Colors'
import Metrics from './Metrics'

const ApplicationStyles = {
    margins: {
        color: {
            backgroundColor: 'red'
        },
        tinyVerticalMargin: {
            marginTop: Metrics.tinyMargin,
            marginBottom: Metrics.tinyMargin
        },
        smallVerticalMargin: {
            marginTop: Metrics.smallMargin,
            marginBottom: Metrics.smallMargin
        },
        baseVerticalMargin: {
            marginTop: Metrics.baseMargin,
            marginBottom: Metrics.baseMargin
        },
        doubleBaseVerticalMargin: {
            marginVertical: Metrics.doubleBaseMargin
        },
        smallHorizontalMargin: {
            marginRight: Metrics.smallMargin,
            marginLeft: Metrics.smallMargin
        },
        baseHorizontalMargin: {
            marginRight: Metrics.baseMargin,
            marginLeft: Metrics.baseMargin
        },
        smallTopMargin: {
            marginTop: Metrics.smallMargin
        },
        baseTopMargin: {
            marginTop: Metrics.baseMargin
        },
        tinyRightMargin: {
            marginRight: Metrics.tinyMargin
        },
        smallRightMargin: {
            marginRight: Metrics.smallMargin
        },
        smallLeftMargin: {
            marginLeft: Metrics.smallMargin
        },
        baseLeftMargin: {
            marginLeft: Metrics.baseMargin
        },
        smallBottomMargin: {
            marginBottom: Metrics.smallMargin
        },
        baseBottomMargin: {
            marginBottom: Metrics.baseMargin
        },
        tinyVerticalPadding: {
            paddingVertical: Metrics.tinyMargin
        },
        smallVerticalPadding: {
            paddingVertical: Metrics.smallMargin
        },
        baseVerticalPadding: {
            paddingVertical: Metrics.baseMargin
        },
        smallHorizontalPadding: {
            paddingHorizontal: Metrics.smallMargin
        },
        baseHorizontalPadding: {
            paddingHorizontal: Metrics.baseMargin
        }
    }, 
    flexBox: {
        column: {
            flexDirection: 'column'
        },
        row: {
            flexDirection: 'row'
        },
        antirow: {
            flexDirection: 'row-reverse'
        },
        flex1: {
            flex: 1
        },
        flex2: {
            flex:2
        },
        flex: {
            flex:3
        },
        justifyContentFlexStart: {
            justifyContent: 'flex-start'
        },
        justifyContentFlexEnd: {
            justifyContent: 'flex-end'
        },
        justifyContentCenter: {
            justifyContent: 'center'
        },
        justifyContentSpaceBetween: {
            justifyContent: 'space-between'
        },
        justifyContentSpaceAround:{
            justifyContent: 'space-around'
        },
        justifyContentSpaceEvenly:{
            justifyContent: 'space-evenly'
        },
        alignItemFlexStart: {
            alignItems: 'flex-start'
        },
        alignItemsFlexEnd: {
            alignItems: 'flex-end'
        },
        alignItemsCenter: {
            alignItems: 'center'
        },
        alignItemsStretch: {
            alignItems: 'stretch'
        },
        centerObjects: {
            justifyContent: 'center',
            alignItems: 'center'
        },
        alignSelfCenter: {
            alignSelf: 'center'
        },
        alignSelfFlexStart: {
            alignSelf: 'flex-start'
        },
        wrap: {
            flexWrap: 'wrap'
        },
        alignContentFlexStart: {
            alignContent: 'flex-start'
        },
        alignContentFlexEnd: {
            alignContent: 'flex-end'
        },
        alignContentCenter: {
            alignContent: 'center'
        },
        alignContentSpaceBetween: {
            alignContent: 'space-between'
        },
        alignContentSpaceAround: {
            alignContent: 'space-around'
        },
        fullWidth: {
            width: '100%'
        },
        fullHeigth: {
            height: '100%'
        },
        deviceHeight: {
            height: Metrics.screenHeight
        }
    },
}

export default ApplicationStyles